// extracted by mini-css-extract-plugin
export default {"management":"management_management__K3zfp","management_button":"management_management_button__yDHeI"};